module.exports = __webpack_public_path__ + "img/rarity-shape2.6c9c1e03.png";